<ng-container *ngIf="launchSource !== 'atlas'">
  <div class="analysis-creation-dialog">
    <p-dialog [(visible)]="showModal" [modal]="true" [dismissableMask]="true" [closable]="true" [position]="'center'"
      [draggable]="false" styleClass="w-50 qubit padding-0" (onHide)="closeDialog()" maskStyleClass="qubit" header="Launch - {{ workspaceSelectorConfig!.title }}">
      <div class="analysis-container d-flex flex-column justify-content-between p-2 gap-1">
        <div class="app-description">
          <p class="label-medium m-0">{{ workspaceSelectorConfig!.description }}</p>
        </div>
        <div class="d-flex flex-column gap-2" *ngIf="!loadingMessage">
          <div class="d-flex flex-column gap-1">
            <label class="align-self-start label-medium"> 1. Select workspace* </label>
            <p-select [styleClass]="'w-100 qubit size-large'" [options]="workspaceList" [(ngModel)]="response.workspace"
              [placeholder]="response.workspace.name ? response.workspace.name : 'Select a Workspace'" [panelStyleClass]="'qubit size-large'"
              [disabled]="isSelectedWorkspace" optionLabel="name" dropdownIcon="polly-icon search" filterPlaceholder="Search"
              [filter]="true" (onShow)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE)" [appendTo]="'body'"
              (onChange)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE_SELECT)">
            </p-select>
            <p *ngIf="!response.workspace.value && submitAttempt && response.workspace.id !== -1"
              class="polly-manage-error-message label-medium">
              Please select a workspace
            </p>
          </div>
          <div class="d-flex flex-column gap-1" *ngIf="response.workspace.name === NEW_WORKSPACE_DROPDOWN_OPTION">
            <label class="align-self-start label-medium"> Name of the Workspace* </label>
            <div class="analysis-input d-flex flex-column gap-1">
              <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.new_workspace_name" pInputText
                (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)" [maxlength]="maxInputLength">
              <p *ngIf="response.new_workspace_name && (response.new_workspace_name.length > maxInputLength-1)"
                class="polly-manage-error-message label-medium">
                Only {{ maxInputLength }} characters are allowed
              </p>
              <p *ngIf="!response.new_workspace_name && workspaceSelectorConfig!.input!.name!.required && submitAttempt"
                class="polly-manage-error-message label-medium">
                Please enter workspace name
              </p>
            </div>
          </div>
          <div class="d-flex flex-column gap-1" *ngIf="isInternalOrgUser">
            <label class="align-self-start label-medium">2. Select a Client Name*</label>
            <p-autocomplete appendTo="body" class="qubit" inputStyleClass="w-100 qubit p-inputtext-lg autocomplete-lg" panelStyleClass="qubit" placeholder="Search Client Organization"
              [ngModel]='selectedClientName' (ngModelChange)="onClientChange($event)" (onSelect)="onOrgSelection($event.value); showLoader = false" [suggestions]="clientOrgList" (completeMethod)="searchOrganizations($event)"
              [dropdown]="true" dropdownMode="current" dropdownIcon="polly-icon caret-down" [minLength]="3">
              <ng-template let-option pTemplate="item">
                <div class="d-flex justify-content-between align-items-center flex-1-1-0">
                  <p class="m-0">{{option.label}}</p>
                  <p class="m-0">{{option.value}}</p>
                </div>
              </ng-template>
            </p-autocomplete>
            <p *ngIf="submitAttempt && !response.client.label && !response.client.value"
              class="polly-manage-error-message label-medium">
              Please select a client
            </p>
          </div>
          <div class="d-flex flex-column gap-1" *ngIf="workspaceSelectorConfig?.input?.name">
            <label class="align-self-start label-medium"> {{ isInternalOrgUser ? 3 : 2 }}. Name of the session* </label>
            <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.analysis.name" pInputText
              (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)">
            <p *ngIf="!response.analysis.name && workspaceSelectorConfig?.input?.name?.required && submitAttempt"
              class="polly-manage-error-message label-medium">
              Please enter analysis name
            </p>
          </div>
          <div class="d-flex flex-column gap-1" *ngIf="workspaceSelectorConfig?.input?.description">
            <label class="align-self-start"> {{ isInternalOrgUser ? 4 : 3 }}. Description </label>
            <textarea rows="7" cols="30" [(ngModel)]="response.analysis.description"
              pTextarea></textarea>
            <p *ngIf="!response.analysis.description && workspaceSelectorConfig?.input?.description?.required && submitAttempt"
              class="polly-manage-error-message label-medium">
              Please enter description
            </p>
          </div>
        </div>
        <ng-container *ngIf="loadingMessage">
          <div class="d-flex flex-column w-100 gap-2">
            <ng-container *ngFor="let _ of [].constructor(3)">
              <div class="gap-1 d-flex flex-column">
                <p-skeleton class="w-20" height="0.875rem" styleClass="qubit"></p-skeleton>
                <p-skeleton class="w-100" height="3rem" styleClass="qubit">
                </p-skeleton>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <ng-template pTemplate="footer">
        <div class="d-flex justify-content-end" *ngIf="loadingMessage">
          <p-skeleton height="2rem" width="5rem" styleClass="qubit"></p-skeleton>
        </div>
        <polly-button *ngIf="!loadingMessage" (click)="setAnalysisConfig(); sendAnalyticsEvent(GTMEvents.APPLICATIONS_SUBMIT);"
                      [label]="'Launch'" [disabled]="showLoader || isInternalOrgUser && !selectedClientName" size="small" [loading]="showLoader">
        </polly-button>
      </ng-template>
    </p-dialog>
  </div>
</ng-container>

<ng-container *ngIf="launchSource === 'atlas'">
  <div *ngIf="!loadingMessage" class="analysis-container d-flex flex-column justify-content-between h-100">
    <div class="d-flex flex-column form-container gap-2 flex-grow">
      <div class="d-flex flex-column gap-1" *ngIf="workspaceSelectorConfig?.input?.name">
        <label class="align-self-start label-medium"> 1. Name of the session </label>
        <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.analysis.name" pInputText
          (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)">
        <p *ngIf="!response.analysis.name && workspaceSelectorConfig?.input?.name?.required && submitAttempt"
          class="polly-manage-error-message label-medium">
          Please enter analysis name
        </p>
      </div>
      <div class="d-flex flex-column gap-1">
        <label class="label-medium"> 2. Select a Workspace </label>
        <p-select class="w-100" [options]="workspaceList" [(ngModel)]="response.workspace" [panelStyleClass]="'qubit size-large'"
          [placeholder]="response.workspace.name ? response.workspace.name : 'Select a Workspace'"
          [disabled]="isSelectedWorkspace" optionLabel="name" dropdownIcon="polly-icon search" filterPlaceholder="Search"
          [filter]="true" (onShow)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE)" appendTo="body"
          (onChange)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE_SELECT)" [styleClass]="'qubit size-large'">
        </p-select>
        <p *ngIf="!response.workspace.value && submitAttempt && response.workspace.id !== -1"
          class="polly-manage-error-message label-medium">
          Please select a workspace
        </p>
      </div>
      <div class="d-flex flex-column gap-1" *ngIf="response.workspace.name === NEW_WORKSPACE_DROPDOWN_OPTION">
        <label class="align-self-start label-medium"> Name of the Workspace </label>
        <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.new_workspace_name" pInputText
               (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)" [maxlength]="maxInputLength">
        <p *ngIf="response.new_workspace_name && (response.new_workspace_name.length > maxInputLength-1)"
           class="polly-manage-error-message label-medium">
          Only {{ maxInputLength }} characters are allowed
        </p>
        <p *ngIf="!response.new_workspace_name && workspaceSelectorConfig?.input?.name?.required && submitAttempt"
           class="polly-manage-error-message label-medium">
          Please enter workspace name
        </p>
      </div>
      <div class="d-flex flex-column gap-1" *ngIf="isInternalOrgUser">
        <label class="align-self-start label-medium">3. Select a Client Name</label>
        <p-autocomplete appendTo="body" class="qubit" inputStyleClass="w-100 qubit p-inputtext-lg autocomplete-lg" panelStyleClass="qubit" placeholder="Search Client Organization"
          [ngModel]='selectedClientName' (ngModelChange)="onClientChange($event)" (onSelect)="onOrgSelection($event.value); showLoader = false" [suggestions]="clientOrgList" (completeMethod)="searchOrganizations($event)"
          [dropdown]="true" dropdownMode="current" dropdownIcon="polly-icon caret-down" [minLength]="3">
          <ng-template let-option pTemplate="item">
            <div class="d-flex justify-content-between align-items-center flex-1-1-0">
              <p class="m-0">{{option.label}}</p>
              <p class="m-0">{{option.value}}</p>
            </div>
          </ng-template>
        </p-autocomplete>
        <p *ngIf="submitAttempt && !response.client.label && !response.client.value"
          class="polly-manage-error-message label-medium">
          Please select a client
        </p>
      </div>
      <div class="d-flex flex-column gap-1" *ngIf="workspaceSelectorConfig?.notebookName">
        <label class="align-self-start label-medium"> {{ isInternalOrgUser ? 4 : 3 }}. Name the Notebook </label>
        <input type="text" pInputText [(ngModel)]='response.notebook_name' class="w-100 qubit p-inputtext-lg"
          placeholder="Enter a Notebook name">
        <p *ngIf="!response.notebook_name && workspaceSelectorConfig?.notebookName?.required && submitAttempt"
          class="polly-manage-error-message label-medium">
          Please enter a notebook name
        </p>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <polly-button class="mt-3" *ngIf="!loadingMessage" [label]="'Launch'" [disabled]="showLoader  || isInternalOrgUser && !selectedClientName" size="medium" [loading]="showLoader"
                    (click)="setAnalysisConfig(); sendAnalyticsEvent(GTMEvents.APPLICATIONS_SUBMIT); sendMixpanelEvent('OmixAtlas_LaunchApp')">
      </polly-button>
    </div>
  </div>
  <ng-container *ngIf="loadingMessage">
    <div class="d-flex flex-column w-100 gap-2">
      <div class="gap-1 d-flex flex-column">
        <p-skeleton class="w-20" height="0.875rem" styleClass="qubit"></p-skeleton>
        <p-skeleton class="w-100" height="3rem" styleClass="qubit">
        </p-skeleton>
      </div>
      <div class="gap-1 d-flex flex-column">
        <p-skeleton class="w-20" height="0.875rem" styleClass="qubit"></p-skeleton>
        <p-skeleton class="w-100" height="3rem" styleClass="qubit">
        </p-skeleton>
      </div>
    </div>
  </ng-container>
</ng-container>
